import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Action, ActionToIconClassMap, IconClass } from './action-to-icon-class-map';
import { TranslationKeyMap } from './translation-key-map';

@Component({
	selector: 'ngx-toolbar-button',
	templateUrl: './toolbar-button.component.html',
	styleUrls: ['./toolbar-button.component.scss'],
	standalone: false
})
export class NgxToolbarButtonComponent implements OnInit {
	@Input() public action: Action;
	@Input() public disabled: boolean = false;
	@Input() public ariaLabel?: string;
	@Output() public clicked: EventEmitter<any> = new EventEmitter();
	public iconClass: IconClass;

	constructor (private translate: TranslateService) {}

	public ngOnInit (): void {
		if (!this.action) {
			throw new Error('Property binding `action` is required!');
		}

		this.iconClass = ActionToIconClassMap[this.action];
	}

	public getTooltipText (): string {
		return this.ariaLabel ?? this.translate.instant(TranslationKeyMap[this.action]);
	}
}
